import React from "react";

const ChatInitializerContext = React.createContext({
    authorLabelResolver: () => "",
    clientPhotoResolver: () => "",
    conversationsGetter: () => [],
    conversationNameResolver: async () => "",
});

export default ChatInitializerContext;
